const GROUP = /\[\s*S\d{1,3}(?:\s*[,،;]\s*S?\d{1,3})*\s*\](?:\s*\[\s*S\d{1,3}\s*\])*/g;

/**
 * The agents cite their sources as `[S1]`, `[S2, S4]`. On screen the marker is a plain footnote number, `[1]` or `[2، 4]`, so no Latin
 * letter reaches the Arabic text and the reading order is the same in both languages.
 */
export const CITATION_HREF = "#cite-";

/** Like {@link citationMarkers}, but each source becomes a markdown link to `#cite-N`, which `MarkdownBody` renders as a hover-card marker. */
export function citationLinks(text: string): string {
  if (!text || !text.includes("S")) return text;
  return text.replace(GROUP, (m) => [...m.matchAll(/\d{1,3}/g)].map((x) => `[${x[0]}](${CITATION_HREF}${x[0]})`).join(""));
}

export function citationMarkers(text: string, locale?: string): string {
  if (!text || !text.includes("S")) return text;
  const ar = (locale ?? (typeof document !== "undefined" ? document.documentElement.lang : "en")).startsWith("ar");
  return text.replace(GROUP, (m) => {
    const numbers = [...m.matchAll(/\d{1,3}/g)].map((x) => x[0]);
    return `[${numbers.join(ar ? "، " : ", ")}]`;
  });
}
